import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const urlscan = defineConnector({
  identifier: "urlscan",
  name: "URLScan",
  tagLine: "URL scanning and analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://urlscan\\.io/api/.*",
  auth: (app) => headerAuth([{ name: "API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Head to the [URLScan settings & API page](https://urlscan.io/user/profile/), and create a new API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "URLScan API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://urlscan.io/api/v1/search/?q=domain:urlscan.io&size=0",
  },
});
